module.exports = __webpack_public_path__ + "static/media/mode-42.052caab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-42.svg
// module id = 1015
// module chunks = 2